import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../styles/styles-css-variables";

import { ReactComponent as SearchIconSvg } from "../../../assets/icons/Icon/DKT/Search black.svg";
import { CloseButtonSvg } from "../../../assets";

import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_MQ } from "../../../styles/breakpoints";
import cn from "classnames";
import { SearchT } from "./search-component";

type Props = {
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  onSubmit: (e: React.FormEvent) => void;
  onClickRemove: () => void;
  t: SearchT;
};

export const SearchPageSearchInput = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  return (
    <form
      onSubmit={props.onSubmit}
      className="u-flex u-jc-center u-items-start"
      css={css`
        margin-top: 20px;
      `}
    >
      <div
        css={css`
          box-shadow: 0 20px 40px 0 rgb(0 0 0 / 12%);
          border: 1px solid ${CSS_COLORS.Gray2024};

          &:focus-within {
            box-shadow: 0 20px 40px 0 rgb(0 0 0 / 20%);
            border: 1px solid #eee;
          }

          --button-width: 58px;

          display: grid;
          grid-template-columns: 1fr var(--button-width) var(--button-width);
          grid-template-rows: 50px;

          border-radius: 8px;

          width: 100%;
          ${CSS_MQ.atLeastSm} {
            width: 400px;
          }
          max-width: 100%;
        `}
      >
        <input
          ref={ref}
          value={props.searchText}
          onChange={evt => props.setSearchText(evt.target.value)}
          placeholder={props.t("enterYourQuery").value}
          css={[
            FONTS.MinervaModern500,
            fontSize.x2,
            css`
              -webkit-appearance: none;
              -moz-appearance: none;

              grid-column: 1 / span 2;
              grid-row: 1;

              height: 50px;
              border: 1px solid white;
              background: #ffffff;

              margin-left: 12px;
              ${CSS_MQ.atLeastMd} {
                margin-left: 20px;
              }
              margin-right: 42px;

              color: ${CSS_COLORS.Black};

              &:focus {
                outline: none !important;
              }
            `,
          ]}
        />

        <button
          onClick={props.onClickRemove}
          type={"button"}
          className={cn({ hidden: props.searchText.length === 0 })}
          css={css`
            grid-column: 2 / span 1;
            grid-row: 1;

            &.hidden {
              visibility: hidden;
            }

            display: flex;
            justify-content: center;
            align-items: center;
          `}
        >
          <CloseButtonSvg
            css={css`
              width: 24px;
              height: 24px;
            `}
          />
        </button>

        <button
          type={"submit"}
          css={css`
            grid-column: 3 / span 1;
            grid-row: 1;

            width: var(--button-width);
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
            padding: 0;

            height: 52px;
            margin: -1px 0;

            background-color: ${CSS_COLORS.Green};
            color: ${CSS_COLORS.White};
          `}
        >
          <SearchIconSvg
            css={css`
              width: 24px;
              height: 24px;
            `}
          />
        </button>
      </div>
    </form>
  );
});
